import { GuiOptions, CookieConsentConfig } from "vanilla-cookieconsent";
import hr from "../../localization/resources/hr";
import en from "../../localization/resources/en";

const CookieUtility = {
  setupCookie: (): CookieConsentConfig["cookie"] => {
    return {
      name: "promet_split_cookie_consent", // ime cookie-a
      domain: window.location.hostname,
      path: "/",
      secure: true,
      expiresAfterDays: 365,
      sameSite: "Lax",
      useLocalStorage: true, // sprema informaciju o prihvaćanju u local storage umjesto u cookie
    };
  },
  getCategories: (): CookieConsentConfig["categories"] => {
    return {
      necessary: {
        enabled: true, // uvijek uključeno
        readOnly: true, // ne može se isključit
      },
    };
  },
  getLanguageOptions: (language: string): CookieConsentConfig["language"] => {
    return {
      default: language,
      translations: {
        en: en.cookies,
        hr: hr.cookies,
      },
    };
  },
  getGuiOptions: (): GuiOptions => {
    return {
      consentModal: {
        layout: "bar inline",
      },
    };
  },
};

export default CookieUtility;
